import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box, Link } from '@mui/material';
import { useCookies } from 'react-cookie';

// ----------------------------------------------------------------------

const Logo = forwardRef(({ disabledLink = false, sx }, ref) => {
  const [cookies] = useCookies();
  const logo = (
    <Box
      component="img"
      ref={ref}
      src="https://www.macrometa.com/docs/img/macrometa-logo.svg"
      sx={{ width: 200, height: 40, cursor: 'pointer', display: 'inline-flex', ...sx }}
    />
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return (
    <Link to={cookies.token ? '/' : '/signin'} component={RouterLink} sx={{ display: 'contents' }}>
      {logo}
    </Link>
  );
});

Logo.propTypes = {
  sx: PropTypes.object,
  disabledLink: PropTypes.bool,
};

export default Logo;
